module.exports = __webpack_public_path__ + "img/sxlogo.d22dfdd7.png";